export const FORM_EVENT_SAVECONTINUELATER = 'saveAndContinueLater';
export const FORM_EVENT_PERIODICSAVE = 'periodicSave';
export const FORM_EVENT_LEAVINGPAGE = 'leavingPage';
export const FORM_EVENT_SUBMITTED = 'submitted';
export const FORM_EVENT_NEXT_PAGE = 'nextPage';
export const FORM_OPEN_CHATBOT = 'openChatbot';

export const FORM_ALL_EVENTS = [
  FORM_EVENT_SAVECONTINUELATER,
  FORM_EVENT_PERIODICSAVE,
  FORM_EVENT_LEAVINGPAGE,
  FORM_EVENT_SUBMITTED,
  FORM_EVENT_NEXT_PAGE,
  FORM_OPEN_CHATBOT,
];
